import { render } from "./MainNavigation.vue?vue&type=template&id=2fc80dc2&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=2fc80dc2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fc80dc2"

export default script